/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CalculateContainerProducts } from './calculate-container-products';

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {Array<CalculateContainerProducts>}
     * @memberof InlineObject
     */
    Products: Array<CalculateContainerProducts>;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    LoadBase: InlineObjectLoadBaseEnum;
    /**
     * ProductNr of the fill up product
     * @type {string}
     * @memberof InlineObject
     */
    FillUpProduct?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObjectLoadBaseEnum {
    Pallet = 'PALLET',
    Sheet = 'SHEET'
}



